import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
} from '@travellegacy/nexops-design-system';
import { Users } from 'lucide-react';
import type { ResponsibleMetric } from '../api/demands.api';
import { formatDurationRich } from '../utils/format-duration';

interface Props {
  metrics: ResponsibleMetric[];
  isLoading: boolean;
}

export function ResponsibleMetricsCard({ metrics, isLoading }: Props) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Users className="h-5 w-5" />
          Tempo médio por responsável
        </CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <p className="text-sm text-muted-foreground">Carregando…</p>
        ) : metrics.length === 0 ? (
          <p className="text-sm text-muted-foreground">
            Sem ciclos fechados no período selecionado.
          </p>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Responsável</TableHead>
                <TableHead className="text-right">Ciclos</TableHead>
                <TableHead className="text-right">Tempo total</TableHead>
                <TableHead className="text-right">Média por ciclo</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {metrics.map((m) => (
                <TableRow key={m.responsibleName}>
                  <TableCell className="font-medium">{m.responsibleName}</TableCell>
                  <TableCell className="text-right tabular-nums">{m.cyclesCount}</TableCell>
                  <TableCell className="text-right tabular-nums">
                    {formatDurationRich(m.totalDurationMs)}
                  </TableCell>
                  <TableCell className="text-right tabular-nums font-mono">
                    {formatDurationRich(m.averageDurationMs)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
}
